import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { getSgmeConfiguration } from 'state/configureStore';

export function useTraceLink(traceId?: string) {
  const isInternal = useIsInternalUser();
  const traceLinkTemplate = getSgmeConfiguration().traceLinkTemplate;
  return traceLinkTemplate && traceId && isInternal ? traceLinkTemplate.replace('{traceId}', traceId || '') : undefined;
}
